export default function NotFound() {
  return (
    <h3>404: page not found!</h3>
  );
}
